<script lang="ts">
  export let width = '34';
  export let height = '32';
  export let color = 'white';
</script>

<svg
  {width}
  {height}
  viewBox="0 0 34 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M25.1758 15.334V25.334H9.17578V15.334"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M27.1738 10.334H7.17383V15.334H27.1738V10.334Z"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M17.1738 25.334V10.334"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M17.1719 10.334H12.6719C12.0088 10.334 11.3729 10.0706 10.9041 9.60175C10.4353 9.13291 10.1719 8.49702 10.1719 7.83398C10.1719 7.17094 10.4353 6.53506 10.9041 6.06622C11.3729 5.59738 12.0088 5.33398 12.6719 5.33398C16.1719 5.33398 17.1719 10.334 17.1719 10.334Z"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M17.1738 10.334H21.6738C22.3369 10.334 22.9728 10.0706 23.4416 9.60175C23.9104 9.13291 24.1738 8.49702 24.1738 7.83398C24.1738 7.17094 23.9104 6.53506 23.4416 6.06622C22.9728 5.59738 22.3369 5.33398 21.6738 5.33398C18.1738 5.33398 17.1738 10.334 17.1738 10.334Z"
    stroke={color}
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
